module.exports = __webpack_public_path__ + "img/red_packet_x2.2ad420c5.png";